<template>
    <div class="flex-1">
        <iframe :src="`https://hris.versatech.com.ph/?sid=${getdata.hris_token}`" style="width: 100%; height: 100%;"></iframe>
    </div>
</template>

<script>
export default {
    computed: {
        getdata() {
            let data = {};
            try {
                var json = JSON.parse(localStorage.getItem('versatechvex_data'));
                if(Object.keys(json).length) {
                    data = json;
                }
            }
            catch(e) {
                return {};
            }

            return data;
        }
    },
}
</script>